import { betGroupKey, groupByMatch } from './betMatch';

// The value of `field` if every bet in the list has the same one (a missing value counts as null), else null.
function sharedValue(bets, field) {
    const values = new Set(bets.map(b => b[field] ?? null));
    return values.size === 1 ? [...values][0] : null;
}

export function GetBetsByFilteredData(model, nameFilter = null) {
    let allBets = model.AllBets;
    //console.log('allBets unfiltered: ', allBets);
    // Apply name filter if provided
    if (nameFilter)
        allBets = allBets.filter(bet => bet.Slug.toLowerCase() === nameFilter.toLowerCase());
   

    //console.log('allBets: ', allBets);

    const groupsByBetTypeId = allBets.reduce((acc, bet) => {
        if (!acc[bet.BetTypeId]) {
            acc[bet.BetTypeId] = [];
        }
        acc[bet.BetTypeId].push(bet);
        return acc;
    }, {});

    const vm = [];
    for (const [betTypeId, bets] of Object.entries(groupsByBetTypeId)) {
        const summaryByBetType = model.SummaryByBetType.find(q => q.BetTypeId == betTypeId);

        summaryByBetType.BetCnt = bets.length;
        summaryByBetType.TotalDonation = bets.reduce((sum, q) => sum + q.TotalBetAmount, 0);
        //summaryByBetType.TotalDonation = 

        const x = {
            BetTypeId: betTypeId,
            SummaryByBetType: summaryByBetType,
            Bets: []
        };

        // Group by BetStr and match within each BetTypeId group
        const groupsByBetStr = bets.reduce((acc, bet) => {
            const key = betGroupKey(bet);
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(bet);
            return acc;
        }, {});

        for (const betsByStr of Object.values(groupsByBetStr)) {
            const totalBetAmount = betsByStr.reduce((sum, bet) => sum + bet.TotalBetAmount, 0);
            const betCnt = betsByStr.length;
            const occured = betsByStr[0].Occured; // Assuming Occured is the same for all bets in this group
            // Floor and cap belong to a single bet, not to the group's total. They are only meaningful on the
            // group when every bet in it has the same limit (always true in a single-user report); otherwise
            // they are shown per user in the breakdown only.
            const bet = {
                BetName: betsByStr[0].BetStr,
                Match: betsByStr[0].Match, // all bets in this group share the same match
                FloorAmount: sharedValue(betsByStr, 'FloorAmount'),
                CapAmount: sharedValue(betsByStr, 'CapAmount'),
                TotalBetAmount: totalBetAmount,
                BetCnt: betCnt,
                BetsByUsers: [],
                Occured: occured
            };

            for (const bbu of betsByStr) {
                const betByUser = {
                    Username: bbu.Username,
                    AmountPerOccurence: bbu.BetPerOccurrence,
                    TotalBetAmount: bbu.TotalBetAmount,
                    FloorAmount: bbu.FloorAmount ?? null,
                    CapAmount: bbu.CapAmount ?? null,
                    Slug: bbu.Slug
                };
                bet.BetsByUsers.push(betByUser);
            }

            // Sort BetsByUsers by TotalBetAmount in descending order, then by Username in ascending order
            bet.BetsByUsers.sort((a, b) => {
                if (b.TotalBetAmount !== a.TotalBetAmount) {
                    return b.TotalBetAmount - a.TotalBetAmount;
                }
                return a.Username.localeCompare(b.Username);
            });

            x.Bets.push(bet);
        }

        // Sort Bets by TotalBetAmount in descending order
        x.Bets.sort((a, b) => b.TotalBetAmount - a.TotalBetAmount);

        // Sections per match, chronological; the amount order above is kept within each section
        x.Sections = groupByMatch(x.Bets);
        vm.push(x);
    }

    var obj = {
        IsSingleUserReport: nameFilter ? true : false,
        AllBetsTotalDonation: allBets.reduce((sum, q) => sum + q.TotalBetAmount, 0),
        AllBetsCnt: allBets.length,
        UserPosition: 0,
        TotalDonators: model.Summary.TotalUsers,
        ByBetType: vm,
        IsHbMember: false
    };

    if (nameFilter) {
        obj.UserPosition = model?.UserRanking.find(q => q.Slug === nameFilter)?.Position || 0;
        obj.Username = model?.UserRanking.find(q => q.Slug === nameFilter)?.Username || null;
        obj.IsHbMember = model?.UserRanking.find(q => q.Slug === nameFilter)?.IsHbMember || false;
    }

    // console.log(vm);
    return obj;
}
